import React from 'react';

import { useSelector } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WButton } from '@wareclouds/wareclouds-ui';
import { useOnlineStatus } from '../common/hooks/useOnlineStatus';
import CustomMessage from '../common/components/Messages/CustomMessage';

const OrderConfirmationModalWrapper = ({
  handleClose,
  handleSubmit,
  buttonLabel,
  submitButtonDisabled,
  isSubmitting,
  showSubmitError,
  children,
  orderCode,
  secondaryButtonLabel,
  onSecondaryButtonClick,
}) => {
  const { t } = useTranslation(['system', 'glossary']);
  const { ordersModalConfig } = useSelector((state) => state.orders);
  const { show, titleOpening, order } = ordersModalConfig;
  const { isOnline } = useOnlineStatus();

  const modalTitle = (
    <Typography
      variant="h6"
      component="p"
      align="left"
      sx={{ textTransform: '', mb: 0 }}
    >
      {`¿${titleOpening} `}
      <Typography
        component="span"
        variant="h6"
        className="fw-bold text-primary"
      >
        {orderCode}
      </Typography>
      {` ${t('of_store', { ns: 'glossary' })}`}
      <Typography
        component="span"
        variant="h6"
        sx={{ fontWeight: 'bold', color: 'primary.main' }}
      >
        {` ${order.ecommerce_name ?? order.id_ecommerce}`}?
      </Typography>
    </Typography>
  );

  return (
    <Dialog
      aria-labelledby="order-confirmation-modal"
      open={show}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogContent sx={{ p: 2 }}>
        <DialogTitle sx={{ px: 0, pt: 0, pb: 1.5 }}>{modalTitle}</DialogTitle>
        <Box
          component="form"
          noValidate
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
          sx={{ width: '100%' }}
        >
          {children}

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            {!isOnline && (
              <Box sx={{ mb: 1.5 }}>
                <CustomMessage
                  message={t('OFFLINE', { ns: 'system' })}
                  variant="error"
                />
              </Box>
            )}

            <WButton
              isDisabled={submitButtonDisabled || !isOnline}
              isLoading={isSubmitting}
              label={buttonLabel}
              variant="contained"
              type="submit"
              fullWidth
            />

            {secondaryButtonLabel && onSecondaryButtonClick && (
              <Box sx={{ mt: 1.5 }}>
                <WButton
                  isDisabled={isSubmitting}
                  label={secondaryButtonLabel}
                  variant="outlined"
                  type="button"
                  fullWidth
                  onClick={(e) => {
                    e.preventDefault();
                    onSecondaryButtonClick();
                  }}
                />
              </Box>
            )}

            {showSubmitError && (
              <Box sx={{ mt: 1 }}>
                <Typography color="error">
                  {t('GENERAL_ERROR', { ns: 'system' })}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default OrderConfirmationModalWrapper;
